import {createContext, useState} from "react";

export const DeviceContext = createContext({})

export const Provider = (props) => {
    const {children} = props;

    let emptyDevice = {
        id: "",
        username: "",
        uniqueId: "",
        platform: "",
        name: "",
        appVersion: "",
        enabled: true,
        main: false
    }

    const [device, setDevice] = useState(emptyDevice);
    const [devices, setDevices] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [deviceDialog, setDeviceDialog] = useState(false);
    const [appVersions, setAppVersions] = useState([]);

    const resetDevice = () => {
        setDevice(emptyDevice);
    };

    // Make the context object:
    const deviceContext = {
        device,
        resetDevice,
        setDevice,
        devices,
        setDevices,
        submitted,
        setSubmitted,
        deviceDialog,
        setDeviceDialog,
        appVersions,
        setAppVersions
    };

    // pass the value in provider and return
    return <DeviceContext.Provider value={deviceContext}>{children}</DeviceContext.Provider>;
}

export const {Consumer} = DeviceContext;
